import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { omit } from "lodash";

const animatedComponents = makeAnimated();

let myModal = {};

export default function ModalStatistics(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [save_data, SetSaveData] = useState({
    from_date: new Date(),
    to_date: new Date(),
  });
  const [user_data, SetUserData] = useState({});

  useEffect(() => {
    console.log("ModalStatistics On mount :", props);
    let myModal1 = document.getElementById("StatisticsModal");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("ModalStatistics On Open :", props);
      myModal = new bootstrap.Modal(
        document.getElementById("StatisticsModal"),
        {}
      );
      var date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth();
      var firstDay = new Date(y, m, 1);
      var lastDay = new Date(y, m + 1, 0);
      SetSaveData((prevValue) => {
        prevValue.from_date = firstDay;
        prevValue.to_date = lastDay;
        return { ...prevValue };
      });
      //   console.log("firstDay :", moment(firstDay).format("DD-MM-yyyy"));
      //   console.log("lastDay :", moment(lastDay).format("DD-MM-yyyy"));
      get_editor();

      myModal.show();
    }
  }, [props.open]);

  async function get_editor() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        from: moment(save_data.from_date).format("DD-MM-yyyy"),
        to: moment(save_data.to_date).format("DD-MM-yyyy"),
      },
    };
    let response = await api("/outlet/get_service_providers", pass_data);
    console.log("get_service_providers response :", response);
    if (response.response.hasOwnProperty("data")) {
      SetUserData(response.response.data[props.user_index]);
    }
  }

  function title_generate(title: any) {
    let replaced_data = title.replaceAll("_", " ");
    var splitStr = replaced_data.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  }

  return (
    <div
      className="modal fade"
      id="StatisticsModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="  modal-title" id="ModalLabel">
              Statistics Modal
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="row">
                <div className="col-6">
                  <label className="form-label">From Date</label>
                  <DatePicker
                    selected={save_data.from_date}
                    onChange={(date) => {
                      console.log("from date :", date);
                      // let from_date_value =
                      //   moment(date).format("DD-MM-yyyy");
                      SetSaveData((prevValue) => {
                        //   prevValue.from_date = from_date_value;
                        prevValue.from_date = date;
                        return { ...prevValue };
                      });
                      get_editor();
                    }}
                    dateFormat="dd-MM-yyyy"
                    className="form-control"
                  />
                </div>
                <div className="col-6">
                  <label className="form-label">To Date</label>
                  <DatePicker
                    selected={save_data.to_date}
                    onChange={(date) => {
                      console.log("to date :", date);
                      // let to_date_value =
                      //   moment(date).format("DD-MM-yyyy");
                      SetSaveData((prevValue) => {
                        //   prevValue.to_date = to_date_value;
                        prevValue.to_date = date;
                        return { ...prevValue };
                      });
                      get_editor();
                    }}
                    dateFormat="dd-MM-yyyy"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="pt-4">

                <div className="row">
                  {user_data.hasOwnProperty(
                    "all_total_service_task_invoiced"
                  ) ? (
                    <div className="col-6 col-md-4 col-lg-3">
                      <div className="border p-2 mb-3 ">
                        <h6 className="fs-6 aHeight text-gray">Service Task Invoiced</h6>
                        <p className="mb-0 text-dark fs-7 fw-bolder pt-2">{user_data.all_total_service_task_invoiced}</p>
                      </div>
                    </div>

                  ) : null}

                  {user_data.hasOwnProperty(
                    "all_total_service_amount_invoiced"
                  ) ? (
                    <div className="col-6 col-md-4 col-lg-3">
                      <div className="border p-2 mb-3 ">
                        <h6 className="fs-6 aHeight text-gray">Service Amount Invoiced</h6>
                        <p className="mb-0 text-dark fs-7 fw-bolder pt-2">{user_data.all_total_service_amount_invoiced}</p>
                      </div>
                    </div>
                  ) : null}

                  {user_data.hasOwnProperty(
                    "all_total_service_task_inreview"
                  ) ? (
                    <div className="col-6 col-md-4 col-lg-3">
                      <div className="border p-2 mb-3 ">
                        <h6 className="fs-6 aHeight text-gray">Service Task Inreview</h6>
                        <p className="mb-0 text-dark fs-7 fw-bolder pt-2">{user_data.all_total_service_task_inreview}</p>
                      </div>
                    </div>
                  ) : null}

                  {user_data.hasOwnProperty(
                    "all_total_service_amount_inreview"
                  ) ? (
                    <div className="col-6 col-md-4 col-lg-3">
                      <div className="border p-2 mb-3 ">
                        <h6 className="fs-6 aHeight text-gray">Service Amount Inreview</h6>
                        <p className="mb-0 text-dark fs-7 fw-bolder pt-2">{user_data.all_total_service_amount_inreview}</p>
                      </div>
                    </div>
                  ) : null}

                  {user_data.hasOwnProperty(
                    "all_total_rework_task_invoiced"
                  ) ? (
                    <div className="col-6 col-md-4 col-lg-3">
                      <div className="border p-2 mb-3 ">
                        <h6 className="fs-6 aHeight text-gray">Rework Task Invoice</h6>
                        <p className="mb-0 text-dark fs-7 fw-bolder pt-2">{user_data.all_total_rework_task_invoiced}</p>
                      </div>
                    </div>
                  ) : null}

                  {user_data.hasOwnProperty(
                    "all_total_rework_amount_invoiced"
                  ) ? (
                    <div className="col-6 col-md-4 col-lg-3">
                      <div className="border p-2 mb-3 ">
                        <h6 className="fs-6 aHeight text-gray">Rework Amount Invoiced</h6>
                        <p className="mb-0 text-dark fs-7 fw-bolder pt-2">{user_data.all_total_rework_amount_invoiced}</p>
                      </div>
                    </div>
                  ) : null}

                  {user_data.hasOwnProperty(
                    "all_total_rework_task_noninvoiced"
                  ) ? (
                    <div className="col-6 col-md-4 col-lg-3">
                      <div className="border p-2 mb-3 ">
                        <h6 className="fs-6 aHeight text-gray">Rework Task Noninvoiced</h6>
                        <p className="mb-0 text-dark fs-7 fw-bolder pt-2">{user_data.all_total_rework_task_noninvoiced}</p>
                      </div>
                    </div>
                  ) : null}

                  {user_data.hasOwnProperty(
                    "all_total_rework_amount_noninvoiced"
                  ) ? (
                    <div className="col-6 col-md-4 col-lg-3">
                      <div className="border p-2 mb-3 ">
                        <h6 className="fs-6 aHeight text-gray">Rework Amount Noninvoiced</h6>
                        <p className="mb-0 text-dark fs-7 fw-bolder pt-2">{user_data.all_total_rework_amount_noninvoiced}</p>
                      </div>
                    </div>
                  ) : null}

                  {user_data.hasOwnProperty(
                    "all_total_rework_task_free"
                  ) ? (
                    <div className="col-6 col-md-4 col-lg-3">
                      <div className="border p-2 mb-3 ">
                        <h6 className="fs-6 aHeight text-gray">Service Amount Inreview</h6>
                        <p className="mb-0 text-dark fs-7 fw-bolder pt-2">{user_data.all_total_rework_task_free}</p>
                      </div>
                    </div>
                  ) : null}


                </div>

              </div>
              <h6 className="fs-5 fw-bolder my-3 px-2">Services</h6>
              {user_data.hasOwnProperty("services")
                ? user_data.services.map((s_ele: any, s_index: any) => (
                  <div className="my-3 border-bottom px-2">
                    <h6 className="my-3">{s_ele.name}</h6>

                    <div className="row">
                      <div className="col-md-6">
                        {s_ele.hasOwnProperty(
                          "total_service_task_invoiced"
                        ) ? (
                          <div className="d-flex px-2 py-1">
                            <p className="text-gray">Service Task Invoiced</p>
                            <p className="ms-auto text-dark fs-6 fw-bolder">{s_ele.total_service_task_invoiced}</p>
                          </div>
                        ) : null}

                        {s_ele.hasOwnProperty(
                          "total_service_quantity_invoiced"
                        ) ? (
                          <div className="d-flex px-2 py-1">
                            <p className="text-gray">Service Quantity Invoiced</p>
                            <p className="ms-auto text-dark fs-6 fw-bolder">{s_ele.total_service_quantity_invoiced}</p>
                          </div>
                        ) : null}

                        {s_ele.hasOwnProperty(
                          "total_service_amount_invoiced"
                        ) ? (
                          <div className="d-flex px-2 py-1">
                            <p className="text-gray">Service Amount Invoiced</p>
                            <p className="ms-auto text-dark fs-6 fw-bolder">{s_ele.total_service_amount_invoiced}</p>
                          </div>
                        ) : null}

                        {s_ele.hasOwnProperty(
                          "total_service_task_inreview"
                        ) ? (
                          <div className="d-flex px-2 py-1">
                            <p className="text-gray">Service Task In Review</p>
                            <p className="ms-auto text-dark fs-6 fw-bolder">{s_ele.total_service_task_inreview}</p>
                          </div>
                        ) : null}

                        {s_ele.hasOwnProperty(
                          "total_service_quantity_inreview"
                        ) ? (
                          <div className="d-flex px-2 py-1">
                            <p className="text-gray">Service Quantity In Review</p>
                            <p className="ms-auto text-dark fs-6 fw-bolder">{s_ele.total_service_quantity_inreview}</p>
                          </div>
                        ) : null}

                        {s_ele.hasOwnProperty(
                          "total_service_amount_inreview"
                        ) ? (
                          <div className="d-flex px-2 py-1">
                            <p className="text-gray">Service Amount In Review</p>
                            <p className="ms-auto text-dark fs-6 fw-bolder">{s_ele.total_service_amount_inreview}</p>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-6">
                        {s_ele.hasOwnProperty(
                          "total_rework_task_invoiced"
                        ) ? (
                          <div className="d-flex px-2 py-1">
                            <p className="text-gray">Rework Task Invoiced</p>
                            <p className="ms-auto text-dark fs-6 fw-bolder">{s_ele.total_rework_task_invoiced}</p>
                          </div>
                        ) : null}

                        {s_ele.hasOwnProperty(
                          "total_rework_amount_invoiced"
                        ) ? (
                          <div className="d-flex px-2 py-1">
                            <p className="text-gray">Rework Amount Invoiced</p>
                            <p className="ms-auto text-dark fs-6 fw-bolder">{s_ele.total_rework_amount_invoiced}
                            </p>
                          </div>
                        ) : null}

                        {s_ele.hasOwnProperty(
                          "total_rework_task_noninvoiced"
                        ) ? (
                          <div className="d-flex px-2 py-1">
                            <p className="text-gray">Rework Task Non Invoiced</p>
                            <p className="ms-auto text-dark fs-6 fw-bolder">{s_ele.total_rework_task_noninvoiced}
                            </p>
                          </div>
                        ) : null}

                        {s_ele.hasOwnProperty(
                          "total_rework_amount_noninvoiced"
                        ) ? (
                          <div className="d-flex px-2 py-1">
                            <p className="text-gray">Rework Amount Non Invoiced</p>
                            <p className="ms-auto text-dark fs-6 fw-bolder">{s_ele.total_rework_amount_noninvoiced}
                            </p>
                          </div>
                        ) : null}

                        {s_ele.hasOwnProperty("total_rework_task_free") ? (
                          <div className="d-flex px-2 py-1">
                            <p className="text-gray">Rework Task Free</p>
                            <p className="ms-auto text-dark fs-6 fw-bolder">{s_ele.total_rework_task_free}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))
                : null}
            </form>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            {props.type == "add" ? (
              <button
                type="button"
                className="btn btn-light-outline"
                onClick={() => {
                  console.log("save");
                  save();
                }}
              >
                Save
              </button>
            ) : null}
            {props.type == "edit" ? (
              <button
                type="button"
                className="btn btn-light-outline"
                onClick={() => {
                  console.log("Update");
                  update_work_salary();
                }}
              >
                Update
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
